import cn from 'classnames'

export const avatarLabelContainerClassName = cn(
   'flex flex-row justify-start items-center w-full'
)

export const avatarLabelWrapper = cn(
   'flex flex-col items-start justify-start grow overflow-hidden'
)

export const labelTextClassName = cn(
   'font-semibold text-gray-700 w-full truncate'
)

export const descriptionClassName = cn(
   'text-gray-600 font-normal w-full truncate'
)
